import { getID } from "src/libs/utilities";

 

export default function cards(): any[] {
    return [
      {
        "id": getID( "cards" ),
        "type": "cards",
        "animated": "fadeInLeft",
        "animated_delay": "waterfall",
        "vertical_align": "full",
        "order": [
          "background",
          "order",
          "title",
          "roles",
          "html",
          "links",
          "empty"
        ],
        "feedType": "carousel",
        "border_radius": 5,
        "gap": 5,
        columns: 4,
        "is_back_image": true,
        is_back_dissolution: true,
        "back_image": "https://i.pinimg.com/736x/bb/13/4e/bb134eedca61a2bca9113c3b5dfdbc49.jpg",
        "card_fields": [
          {
            type: "background",
            style : {
                height: 330,
            }
          },
          {
            type: "order",
            "significant_zero": true,
            "card_fields_style": {
              "position": "absolute",
              "top": 10,
              "right": 10
            },
            "style": {
              "borderRadius": 2,
              "color": "#000000",
              "fontFamily": "Yanone Kaffeesatz, sans-serif",
              "fontSize": 50,
              "opacity": 0.33,
              "width": 70,
              "height": 70,
              "border": "#00000075 solid 1px",
              "display": "flex",
              "justifyContent": "center",
              "alignItems": "center",
              "backgroundColor": "#FFFFFF"
            }
          },
          {
            type: "title",
            "style": {
              "padding": 10,
              "backgroundColor": "var(--force-plain-opacity-color)",
              "margin": "0px 10px",
              "display": "flex",
              "justifyContent": "center",
              "alignItems": "center",
              "fontWeight": "bold"
            }
          }, 
          {
            type: "html",
            "style": {
              "padding": "0 12px 12px 12px",
              "fontSize": ".9em",
              "letterSpacing": 1,
              "backgroundColor": "var(--force-plain-opacity-color)",
              "margin": "0px 10px"
            }
          },
          {
            type: "divider",
          },
          {
            type: "personal_link",
            "personalLinkType": "small",
            "style": {
              "padding": "12px 0",
              "backgroundColor": "var(--force-plain-opacity-color)",
              "margin": "0px 10px"
            }
          },
          {
            type: "statistic_line",
            "items": [
              { "id": "8-1", "title": "Известность" },
              { "id": "8-2", "title": "Порядочность" },
              { "id": "8-3", "title": "Талант" },
              { "id": "8-4", "title": "Чистоплотность" }
            ],
            "min": 0,
            "max": 5,
            "style": {
              "backgroundColor": "var(--force-plain-opacity-color)",
              "margin": "0px 10px"
            }
          },
          {
            type: "tags",
            "className": "my-1",
            "style": {
              "padding": "5px 0",
              "backgroundColor": "var(--force-plain-opacity-color)",
              "margin": "0px 10px",
              "width": "auto"
            }
          },
          {
            type: "empty",
            style: {
              height: 10
            }
          }
        ],
        "cards": [
          {
            "id": getID( "card" ),
            value : [
              {
                "id": getID( "background" ),
                "data": "https://i.pinimg.com/1200x/3d/f1/ba/3df1ba7b5a9b93e064c68e94e1e3d6c2.jpg"
              },
              {
                "id": getID( "order" ),
              },
              { 
                "id": getID( "title" ),
                "data": "Дед Пердед Шелковистов" 
              },
              {                  
                "id": getID( "html" ),
                "data": "Знакомьтесь, фермер Володя aka дед пердед ! Герой нашего нового фильма. Господи вот это годнота! Такого треша я еще не видела ))) спасибо за труд!"
              },
              {
                "id": getID( "divider" ),
              },
              {
                "id": getID( "personal_link" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933556371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              { 
                "id": getID( "statistic_line" ),
                "data": [32, 6, 98, 26] 
              },
              { 
                "id": getID( "tags" ),
                "data": [{ "_id": "8-11", "title": "Клошарик-3" }] 
              },
              { 
                "id": getID( "empty" ),
              },
            ]
          },
          {
            "id": getID( "card" ),
            value: [
              {
                
                "id": getID( "background" ),
                "data": "https://i.pinimg.com/1200x/84/34/e3/8434e3c3945295ac2f37f0de75d79d69.jpg"
              },
              {
                "id": getID( "order" ),
              },
              { 
                "id": getID( "title" ),
                "data": "Манихей Подпермышкин-Фиговинский" 
              },
              { 
                "id": getID( "html" ),
                "data": "description" 
              },
              {
                "id": getID( "divider" ),
              },
              {
                "id": getID( "personal_link" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              { 
                "id": getID( "statistic_line" ),
                "data": [48, 42, 87, 93] 
              },
              { 
                "id": getID( "tags" ),
                "data": [{ "_id": "8-21", "title": "Минорик" }] 
              },
              { 
                "id": getID( "empty" ),
              },
            ]
          },
          {
            "id": getID( "card" ),
            value: [
              {
                "id": getID( "background" ),
                "data": "https://i.pinimg.com/1200x/86/fc/36/86fc3658e9c6b2a25fc4ec1b011366de.jpg"
              },
              {
                "id": getID( "order" ),
              },
              { "id": getID( "title" ), "data": "Хамфри Бугурд" }, 
              {
                "id": getID( "html" ),
                "data": "американский киноактёр. Американский институт киноискусства назвал Бугурда лучшим актёром в истории американского кино. Сменив несколько занятий, в 1921 году Бугурд стал актёром"
              },  
              {
                "id": getID( "divider" ),
              },             
              {
                "id": getID( "personal_link" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933556371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              { "id": getID( "statistic_line" ), "data": [99, 11, 43, 65] },
              {
                "id": getID( "tags" ),
                "data": [
                  { "_id": "8-31", "title": "Актёр" },
                  { "_id": "8-32", "title": "Мастадонт" },
                  { "_id": "8-33", "title": "Коллекционер суккулентов" }
                ]
              },
              { 
                "id": getID( "empty" ),
              },
            ]
          },
          {
            "id": getID( "card" ),
            value: [
              {
                "id": getID( "background" ),
                "data": "https://i.pinimg.com/1200x/b4/f0/55/b4f0554c79a74b0f4e503c2e057f2a92.jpg"
              },
              {
                "id": getID( "order" ),
              },
              { "id": getID( "title" ), "data": "Уильям Генри Лейн" },
              {
                "id": getID( "html" ),
                "data": "Первым признанным танцоров чечетки был Уильям Генри Лейн (William Henry Lane), известный как мастер Juba. Это был первый афроамериканский степер, который танцевал наравне с белыми танцорами."
              },
              {
                "id": getID( "divider" ),
              },
              {
                "id": getID( "personal_link" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933556371",
                    "dzen": "bobo@email.bo"
                  }
                }
              },
              { "id": getID( "statistic_line" ), "data": [100, 11, 43, 65, 87] },
              {
                "id": getID( "tags" ),
                "data": [
                  { "_id": "8-41", "title": "Композитор" },
                  { "_id": "8-42", "title": "Певец" },
                  { "_id": "8-43", "title": "Танцор чечотки" }
                ]
              },
              { 
                "id": getID( "empty" ),
              },
            ]
          }
        ],
        defaultTitle: "Карточки с изображением на фоне"
      },
      { 
        id: getID( "cards" ),
        type: "cards", 
        animated: "fadeInUp",
        animated_delay: "waterfall",
        order: [ "image", "medallion", "title", "html", "personal_link" ],
        vertical_align: "minimal",
        border_radius: 8, 
        gap: 30,
        columns: 4,
        back_color: "var(--force-plain-opacity-color)",
        is_back_dissolution: true,
        card_fields: [
            {
              "id": "image",
              "type": "image",
              "hover_size": 10,
              "style": { "height": 200 }
            },
            {
              "id": "medallion",
              "type": "medallion",
              "radius": 100,
              "icon": "https://i.pinimg.com/1200x/8c/6e/f2/8c6ef2716fe3e235e15e3e8c9bef4727.jpg",
              "margin": 10,
              "hover_size": -3,
              "color": "#FFFFFF"
            },
            { "id": "title", "type": "title" },
            { "id": "html", "type": "html" },
            {
              "id": "checkbox",
              "type": "checkbox",
              "isHidden": 1,
              "tags": [],
              "style": { "marginBottom": 30 }
            },
            {
              "id": "cropped_divider",
              "type": "cropped_divider",
              "isHidden": 1,
              "divider_type": "wave_outline_reverse",
              "divider_width": "100%",
              "divider_color": "#4a6471",
              "divider_height": 330
            },
            {
              "id": "personal_link",
              "type": "personal_link",
              "personalLinkType": "outline",
              "style": {}
            },
            {
              "id": "inner_link",
              "type": "inner_link",
              "isHidden": 1,
              "style": { "height": 115, "paddingBottom": 10 }
            }
        ],
        cards: [
          {
            "id": getID( "" ),
            "cardColor": "#3b291e66",
            "cardTitle": "Путь становления лингвистом",
            "cardDescription--": "Строительная отрасль во все времена была главнейшим направлением в развитии любой цивилизации.",
            "cardIcon": "fas fa-carrot",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/bc/56/02/bc560298c9ad58b79a8ee52d9f74bc77.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/4a/97/06/4a97062d4a2cf28405f8a08e3fc4b893.jpg"
              },
              { "id": getID( "" ), data: "Путь становления лингвистом" },
              {
                "id": getID( "" ),
                "data": "<p>Строительная отрасль во все времена была главнейшим направлением в развитии любой цивилизации."
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 0, "title": "Вечно" },
                  { "checked": 0, "title": "Круглосуточная поддержка" },
                  { "checked": 0, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
          {
            "id": getID( "" ),
            "cardColor": "#6f776066",
            "cardTitle": "оя будущая профессия — военный инженер",
            "cardDescription--": "Очень распространённым штампом в романах-фэнтези является изображение медицины и процесса лечения",
            "cardIcon": "fas fa-boxes",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/e3/ee/f4/e3eef4da1eb57db0d71d9574b6542f6e.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/5a/e6/c8/5ae6c82a4e0b510fcb39b7674627ca55.jpg"
              },
              {
                "id": getID( "" ),
                "data": "Моя будущая профессия — военный инженер."
              },
              {
                "id": getID( "" ),
                "data": "Очень распространённым штампом в романах-фэнтези является изображение медицины и процесса лечения, завязанного на суевериях и полуволшебных практиках."
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 1, "title": "Вечно" },
                  { "checked": 1, "title": "Круглосуточная поддержка" },
                  { "checked": 0, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "dzen": "https://dzen.me/341235677",
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://ru.pinterest.com/pin/39688040460739816/",
                    "rutube": "https://rutube.ru/video/69cd337cda701e0f513626f107321c3c/"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
          {
            "id": getID( "" ),
            "cardColor": "#51729466",
            "cardTitle": "Вулканы Камчатки",
            "cardDescription--": "Обычно при упоминании о средневековых войсках вспоминаются либо крестоносцы",
            "cardIcon": "fas fa-smog",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/77/d1/54/77d15495d2a1341e5db7629cccc3b90f.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/81/ac/95/81ac95e4285a7b7b8f51ddad5ab29514.jpg"
              },
              { "id": getID( "" ), "data": "Вулканы Камчатки" },
              {
                "id": getID( "" ),
                "data": "<p>Обычно при упоминании о средневековых войсках вспоминаются либо крестоносцы, либо просто рыцари, с ног до головы закованные в латы и сидящие на коне. "
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 1, "title": "Вечно" },
                  { "checked": 1, "title": "Круглосуточная поддержка" },
                  { "checked": 1, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null, "style": { "fill": "red" } },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-1830250_17103",
                    "telegram": "https://te.me/341235677",
                    "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                    "odnoklassniki": "https://ok.ru/cinemastar/topic/1565759335506371",
                    "at": "bobo@email.bo"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
          {
            "id": getID( "" ),
            "cardColor": "#0c51897d",
            "cardTitle": "Где и как этому учат Хобутаниди Диана",
            "cardDescription--": "Жара стихла (сегодня мне сказали, что дождя нет из-за того, что грешили много, о как)",
            "cardIcon": "fas fa-cat",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/72/79/31/72793136020004e2ef5a4206946fbe73.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/01/bd/fa/01bdfaf148d04e8e4a4464018cb6765c.jpg"
              },
              {
                "id": getID( "" ),
                "data": "Где и как этому учат Хобутаниди Диана"
              },
              {
                "id": getID( "" ),
                "data": "<p>Жара стихла (сегодня мне сказали, что дождя нет из-за того, что грешили много, о как), я отошел от подвигов и выбрался на базарчик."
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 1, "title": "Вечно" },
                  { "checked": 1, "title": "Круглосуточная поддержка" },
                  { "checked": 1, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
          {
            "id": getID( "" ),
            "cardColor": "#548ab766",
            "cardTitle": "Патрики",
            "cardDescription--": "Мужчину в костюме лебедя",
            "cardIcon": "fas fa-dog",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/11/a1/6e/11a16e465bd2cfe140bd6da01d89a01c.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/11/af/87/11af87e8690f61773f2b33aff802009e.jpg"
              },
              { "id": getID( "" ), "data": "Патрики" },
              {
                "id": getID( "" ),
                "data": "<p>Мужчину в костюме лебедя, который устроил заплыв на сапборде, задержали на Патриарших прудах."
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 1, "title": "Вечно" },
                  { "checked": 1, "title": "Круглосуточная поддержка" },
                  { "checked": 1, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
          {
            "id": getID( "" ),
            "cardColor": "#0b559366",
            "cardTitle": "Не пропустите:",
            "cardDescription--": "Обещают сегодня лунное затмение -- «кровавую луну»",
            "cardIcon": "fas fa-helicopter",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/d9/2b/e1/d92be121852969d1e5df67d8e06058ef.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/55/f4/3c/55f43c973eb2a4fb12fa6cbeb8496f45.jpg"
              },
              { "id":getID( "" ), "data": "лучше носить шапку" },
              {
                "data": "<p>В преддверии зимы кандидат медицинских наук Андрей Петрович Кондрахин из Пироговского Университета напоминает, почему лучше носить шапку, чем не носить",
                "id": getID( "" )
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 1, "title": "Вечно" },
                  { "checked": 1, "title": "Круглосуточная поддержка" },
                  { "checked": 1, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
          {
            "id": getID( "" ),
            "cardColor": "#0b559366",
            "cardTitle": "Не пропустите:",
            "cardDescription--": "Обещают сегодня лунное затмение -- «кровавую луну»",
            "cardIcon": "fas fa-helicopter",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/66/43/96/6643960867046dc6109fc00c2b8e62d3.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/8a/df/e0/8adfe0e948eae8af71c7302ce0e6ccb1.jpg"
              },
              { "id":getID( "" ), "data": "И такое в Париже есть" },
              {
                "data": "<p>Дом инвалидов или Дворце инвалидов. Звучит диковато для уха, особенно по отношению к памятнику архитектуры. На самом деле все просто: Hôtel des Invalides был построен по приказу короля Людовика XIV в 1670 году в качестве пристанища заслуженных армейских ветеранов, то есть инвалидов войны.",
                "id": getID( "" )
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 1, "title": "Вечно" },
                  { "checked": 1, "title": "Круглосуточная поддержка" },
                  { "checked": 1, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
          {
            "id": getID( "" ),
            "cardColor": "#0b559366",
            "cardTitle": "Не пропустите:",
            "cardDescription--": "Обещают сегодня лунное затмение -- «кровавую луну»",
            "cardIcon": "fas fa-helicopter",
            "value": [
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/1200x/f8/cf/d7/f8cfd70d6375c8e63de67ce61647f977.jpg"
              },
              {
                "id": getID( "" ),
                "data": "https://i.pinimg.com/736x/94/98/25/9498254fd0d4dcda615a8e13ee0a670f.jpg"
              },
              { "id":getID( "" ), "data": "Не пропустите:" },
              {
                "data": "<p>Обещают сегодня лунное затмение -- «кровавую луну». )))",
                "id": getID( "" )
              },
              {
                "id": getID( "" ),
                "data": [
                  { "checked": 1, "title": "Совершенно бесплатно" },
                  { "checked": 1, "title": "Вечно" },
                  { "checked": 1, "title": "Круглосуточная поддержка" },
                  { "checked": 1, "title": "Бутерброд в подарок" }
                ]
              },
              { "id": getID( "" ), "data": null },
              {
                "id": getID( "" ),
                "data": {
                  "sc": {
                    "vk": "https://vk.com/feed?w=wall-162479647_729613",
                    "odnoklassniki": "https://ok.ru/bstroyka",
                    "telegram": "https://te.me/341235677"
                  }
                }
              },
              {
                "id": getID( "" ),
                "data": { "url": "/", "label": "Goto" }
              }
            ],
            "style": {}
          },
        ],
        defaultTitle: "Карточки с миниатюрой и медальоном"
      },
      {
          "id": getID("cards"),
          "type": "cards",
          "feedType": "vertical_timeline",
          "vertical_align": "full",
          "border_radius": 12,
          "order": ["title", "time"],
          "gap": 25,
          "is_two_side": 1,
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "border": {
            "stroke": "var(--force-contrast-opacity-color)",
            "strokeWidth": 1,
            "borderType": ""
          },
          "dots": {
            "type": "sinusoid",
            "perimeter": 90,
            "color": "var(--force-contast-color)",
            "fontColor": "var(--force-plain-color)",
            "fontSize": 33,
            "weight": 1,
            "round": 90,
            "significant_zero": true,
            "amplitude": 0,
            "image": "https://i.pinimg.com/736x/9d/1d/10/9d1d108b34722181206e31ef94b61e1f.jpg",
            "length": 0.6,
            "phase": 0,
            "stroke_width": 2, 
            "dot_style": { "border": "2px solid var(--force-contast-color)" }
          },
          "card_fields": [
            {
              "id":  getID("medallion"),
              "type": "medallion",
              "radius": 100,
              "icon": "https://i.pinimg.com/1200x/8c/6e/f2/8c6ef2716fe3e235e15e3e8c9bef4727.jpg",
              "margin": 1,
              "hover_size": 4,
              "color": "#FFFFFF"
            },
            {
              "id":  getID("title"),
              "type" : "title",
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "borderBottom": "1px solid var(--force-mini-contast-color)",
                "textTransform": "uppercase"
              }
            },
            {
              "id":  getID("time"),
              "type": "time",
              "style": { "display": "flex", "justifyContent": "center" },
              "format": "D MMM YY года",
              "className": "p-2 my-3 bg-transparent lead",
              "labelClassName": "",
              "minimal": true
            } 
          ],
          "cards": [
            {
              "id":  getID("card"),
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/736x/73/34/1e/73341e55f84a37f96b05bc3e892d9d9b.jpg"
                },
                { id:  getID("title"), "data": "Такт 1.Защиты жизненных проектов 11-классниками" },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id": "102-card-1-2",
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/736x/ba/4d/1e/ba4d1e57795d90cd7ac38fa0022b2139.jpg"
                },
                { id:  getID("title"), "data": "Такт 2. Рефлексия интересов, опыта и возможностей" },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id": "103-card-3",
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/1200x/8e/2d/e9/8e2de97b72a3c5c28df482571ef94e85.jpg"
                },
                {
                  id:  getID("title"), "data": "Такт 13. Игра «Территория» - решение правовых и финансовых ситуаций"
                },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id": "104-card-4",              
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/736x/ae/b3/c0/aeb3c0c76d54fda9ce6700be8b0410ae.jpg"
                },
                {
                  id:  getID("title"), "data": "Такт 4. Анализ профессий и вариантов образования"
                },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 } 
              ]
            },
            {
              "id":  getID("medallion"),
              "value": [
                {
                  "id": "5-medallion",
                  "data": "https://i.pinimg.com/736x/46/2a/8b/462a8b4fce68897204310664192275b8.jpg"
                }, 
                {
                  id:  getID("title"), "data": "Такт 5. Выбор профессии, проектирование траектории"
                },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            }
          ],
          "style": { "border": "1px solid var(--force-contast-color)" },
          defaultTitle: "Вертикальный таймлайн с огромными бляхами"
      },
      {
          "id": getID("cards"),
          "type": "cards",
          "feedType": "vertical_timeline",
          "vertical_align": "full",
          "border_radius": 12,
          "order": ["title", "time"],
          "gap": 25,
          "is_two_side": 1,
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "border": {
            "stroke": "var(--force-contrast-opacity-color)",
            "strokeWidth": 1,
            "borderType": ""
          },
          "dots": {
            "type": "sinusoid",
            "perimeter": 29,
            "color": "var(--force-plain-color)",
            "fontColor": "var(--force-contast-color)",
            "fontSize": 13,
            "weight": 1,
            "round": 3,
            "significant_zero": false,
            "amplitude": 0,
            "image": "https://i.pinimg.com/736x/9d/1d/10/9d1d108b34722181206e31ef94b61e1f.jpg",
            "length": 0.6,
            "phase": 0,
            "stroke_width": 30,
            "svg_style": { "strokeDasharray": "4 2" },
            "dot_style": { "border": "2px solid var(--force-contast-color)" }
          },
          "card_fields": [
            {
              "id": getID("medallion"), 
              "type": "medallion",
              "radius": 100,
              "icon": "https://i.pinimg.com/1200x/8c/6e/f2/8c6ef2716fe3e235e15e3e8c9bef4727.jpg",
              "margin": 10,
              "hover_size": 3,
              "color": "#FFFFFF"
            },
            {
              "id": getID("title"), 
              "type" : "title",
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "borderBottom": "1px solid var(--force-mini-contast-color)",
                "textTransform": "uppercase"
              }
            },
            {
              "id": getID("time"), 
              "type": "time",
              "style": { "display": "flex", "justifyContent": "center" },
              "format": "D MMM YY года",
              "className": "p-2 my-3 bg-transparent lead",
              "labelClassName": "",
              "minimal": true
            } 
          ],
          "cards": [
            {
              "id": getID("card"),
              "value": [
                {
                  "id": getID("medallion"), 
                  "data": "https://i.pinimg.com/736x/73/34/1e/73341e55f84a37f96b05bc3e892d9d9b.jpg"
                },
                { id: getID("title"), "data": "Такт 1.Защиты жизненных проектов 11-классниками" },
                { id: getID("time"),"start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id":getID("cards"),
              "value": [
                {
                  "id": getID("medallion"), 
                  "data": "https://i.pinimg.com/736x/ba/4d/1e/ba4d1e57795d90cd7ac38fa0022b2139.jpg"
                },
                { id: getID("title"), "data": "Такт 2. Рефлексия интересов, опыта и возможностей" },
                { id: getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id": getID("cards"),
              "value": [
                {
                  id: getID("medallion"), 
                  "data": "https://i.pinimg.com/1200x/8e/2d/e9/8e2de97b72a3c5c28df482571ef94e85.jpg"
                },
                {
                  id: getID("title"), 
                  "data": "Такт 13. Игра «Территория» - решение правовых и финансовых ситуаций"
                },
                { id: getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              id: getID("cards"),               
              "value": [
                {
                  id: getID("medallion"), 
                  "data": "https://i.pinimg.com/736x/ae/b3/c0/aeb3c0c76d54fda9ce6700be8b0410ae.jpg"
                },
                {
                  id: getID("title"), "data": "Такт 4. Анализ профессий и вариантов образования"
                },
                { id: getID("time"), "start_time": 1757997073, "finish_time": 1757997105 } 
              ]
            },
            {
              id: getID("card"), 
              "value": [
                {
                  id: getID("medallion"), 
                  "data": "https://i.pinimg.com/736x/46/2a/8b/462a8b4fce68897204310664192275b8.jpg"
                }, 
                {
                  id: getID("title"), "data": "Такт 5. Выбор профессии, проектирование траектории"
                },
                { id: getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            }
          ],
          "style": { "border": "1px solid var(--force-contast-color)" },
          defaultTitle: "Таймлайн-ремешок"
      },
      {
          "id": getID("cards"),
          "type": "cards",
          "feedType": "vertical_timeline",
          "vertical_align": "full",
          "border_radius": 12,
          "order": ["title", "time"],
          "gap": 25,
          "is_two_side": 1,
          "animated": "fadeInLeft",
          "animated_delay": "waterfall",
          "border": {
            "stroke": "var(--force-contrast-opacity-color)",
            "strokeWidth": 1,
            "borderType": ""
          },
          "dots": {
            "type": "sinusoid",
            "perimeter": 30,
            "color":  "var(--force-contast-color)",
            "fontColor": "var(--force-plain-color)",
            "fontSize": 12,
            "weight": 1,
            "round": 30,
            "significant_zero": false,
            "amplitude": 90,
            "image": "https://i.pinimg.com/736x/9d/1d/10/9d1d108b34722181206e31ef94b61e1f.jpg",
            "length": 0.6,
            "phase": 3,
            "stroke_width": 2, 
            "dot_style": { "border": "1px solid var(--force-contast-color)" }
          },
          "card_fields": [
            {
              "id":  getID("medallion"),
              "type": "medallion",
              "radius": 100,
              "icon": "https://i.pinimg.com/1200x/8c/6e/f2/8c6ef2716fe3e235e15e3e8c9bef4727.jpg",
              "margin": 1,
              "hover_size": 4,
              "color": "#FFFFFF"
            },
            {
              "id":  getID("title"),
              "type" : "title",
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "borderBottom": "1px solid var(--force-mini-contast-color)",
                "textTransform": "uppercase"
              }
            },
            {
              "id":  getID("time"),
              "type": "time",
              "style": { "display": "flex", "justifyContent": "center" },
              "format": "D MMM YY года",
              "className": "p-2 my-3 bg-transparent lead",
              "labelClassName": "",
              "minimal": true
            } 
          ],
          "cards": [
            {
              "id":  getID("card"),
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/736x/73/34/1e/73341e55f84a37f96b05bc3e892d9d9b.jpg"
                },
                { id:  getID("title"), "data": "Такт 1.Защиты жизненных проектов 11-классниками" },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id": "102-card-1-2",
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/736x/ba/4d/1e/ba4d1e57795d90cd7ac38fa0022b2139.jpg"
                },
                { id:  getID("title"), "data": "Такт 2. Рефлексия интересов, опыта и возможностей" },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id": "103-card-3",
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/1200x/8e/2d/e9/8e2de97b72a3c5c28df482571ef94e85.jpg"
                },
                {
                  id:  getID("title"), "data": "Такт 13. Игра «Территория» - решение правовых и финансовых ситуаций"
                },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            },
            {
              "id": "104-card-4",              
              "value": [
                {
                  "id":  getID("medallion"),
                  "data": "https://i.pinimg.com/736x/ae/b3/c0/aeb3c0c76d54fda9ce6700be8b0410ae.jpg"
                },
                {
                  id:  getID("title"), "data": "Такт 4. Анализ профессий и вариантов образования"
                },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 } 
              ]
            },
            {
              "id":  getID("medallion"),
              "value": [
                {
                  "id": "5-medallion",
                  "data": "https://i.pinimg.com/736x/46/2a/8b/462a8b4fce68897204310664192275b8.jpg"
                }, 
                {
                  id:  getID("title"), "data": "Такт 5. Выбор профессии, проектирование траектории"
                },
                { id:  getID("time"), "start_time": 1757997073, "finish_time": 1757997105 }
              ]
            }
          ],
          "style": { "border": "1px solid var(--force-contast-color)" },
          defaultTitle: "Вертикальный таймлайн-змейка"
      },
      {
        "id":  getID("cards"),
        "type": "features_cards",
        "feedType": "vertical_timeline",
        "vertical_align": "full",
        "border_radius": 3,
        "order": ["iconMedallion", "title", "divider", "checkbox"],
        "gap": 25,
        "is_two_side": 1,
        "animated": "fadeInLeft",
        "animated_delay": "waterfall",
        "border": {
          "stroke": "var(--force-contrast-opacity-color)",
          "strokeWidth": 1,
          "borderType": "nose"
        }, 
        "dots": {
          "type": "gallery",
          "perimeter": 36,
          "color": "var(--force-plain-color)",
          "fontColor": "var(--force-contast-color)",
          "fontSize": 13,
          "weight": 1,
          "round": 22,
          "significant_zero": true,
          "amplitude": 40,
          "image": "https://i.pinimg.com/736x/f4/c8/00/f4c80066ccd0c185b8404e45a0aba264.jpg",
          "length": 0.45,
          "phase": 3.141,
          "stroke_width": 200, 
          "dot_style": { "border": "2px solid var(--force-contast-color)" }
        },
        "card_fields": {
          "icon": {
            "id":  getID("icon"),
            "style": { "backgroundSize": 70, "backgroundRepeat": "no-repeat" }
          },
          "iconMedallion": {
            "id":  getID("icon-medallion"),
            "radius": 100,
            "margin": 25,
            "style": {
              "backgroundColor": "var(--force-plain-color)",
              "border": "1px solid var(--force-mini-contast-color)",
              "boxShadow": "0 7px 5px 0px #00000012"
            }
          },
          "title": {
            "id":  getID("title"),
            "style": {
              "fontWeight": 100,
              "fontSize": 18,
              "borderBottom": "1px solid var(--force-mini-contast-color)",
              "textTransform": "uppercase"
            }
          },
          "speech_bubble": {
            "id":  getID("speech-bubble"),
            "strokeWidth": 2,
            "tailPositionX": 85,
            "style": {
              "boxShadow": "0 7px 5px 0px #00000012",
              "marginButtom": -10
            },
            "data": { "type": "html", "className": "py-2 px-3" }
          },
          "person": { "id":  getID("person"), "data": { "avatarWidth": 75, "avatarHeight": 75 } },
          "checkbox": { "id":  getID("check-box"), "style": { "padding": "10px 30px" } },
          "button": {
            "id":  getID("buttons"),
            "style": {
              "height": "auto",
              "padding": "20px",
              "paddingBottom": "auto"
            }
          },
          "divider": { "id":  getID("divider"),"divider_height": "0px" }
        },
        "cards": [
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
            },
            "iconMedallion": {
              "id":  getID("medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
            },
            "title": { "id":  getID("title"), "data": "Втираемся в доверие" },
            "speech_bubble": {
              "data": {
                "id":  getID("bubble"),
                "data": "<p>Это всё конечно хорошо. Это просто радувает нас, как ёлочка"
              }
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "second_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg"
                }
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 0 }
              ]
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"), 
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
            },
            "title": {
              "id":  getID("title"),
              "data": "Комические куплеты",
              "style": { "color": "var(--actual-success-color)" }
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "102-card-1-bubble",
                "data": "<p>Реальность — это суровое место..."
              }
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "second_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg"
                }
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 0 },
                { "title": "Входим в двери", "checked": 0 },
                { "title": "Шаманим", "checked": 1 }
              ]
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Сбыча" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "103-card-1-bubble",
                "data": "<p>На Урале какие-то люди может быть есть. Тогда за три дня не удалось..."
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 0 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 1 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Поначалу" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "104-card-1-bubble",
                "data": "<p>Нам нужен мощный телепат"
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 0 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Красные ступени" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "105-card-1-bubble",
                "data": "<p>Она хотела, чтобы ее выслушали..."
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 0 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "15",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("button"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Хорошие дни" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "106-card-1-bubble",
                "data": "<p>Будто ловит мысли из чужого мира."
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 0 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "15",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          }
        ],
        "style": { "border": "1px solid var(--force-contast-color)" },
          defaultTitle: "Вертикальный таймлайн с внедрённым изображением"
      },
      {
        "id":  getID("cards"),
        "type": "features_cards",
        "feedType": "vertical_timeline",
        "vertical_align": "full",
        "border_radius": 3,
        "order": ["iconMedallion", "title", "divider", "checkbox"],
        "gap": 25,
        "is_two_side": 1,
        "animated": "fadeInLeft",
        "animated_delay": "waterfall",
        "border": {
          "stroke": "var(--force-contrast-opacity-color)",
          "strokeWidth": 1,
          "borderType": "nose"
        }, 
        "dots": {
          "type": "gallery",
          "perimeter": 36,
          "color": "var(--force-plain-color)",
          "fontColor": "var(--force-contast-color)",
          "fontSize": 13,
          "weight": 1,
          "round": 22,
          "significant_zero": true,
          "amplitude": 0,
          "image": "https://i.pinimg.com/736x/32/1a/95/321a95d0050a1475ad94233b15c8ae9a.jpg",
          "length": 0.45,
          "phase": 3.141,
          "stroke_width": 160, 
          "dot_style": { "border": "2px solid var(--force-contast-color)" }
        },
        "card_fields": {
          "icon": {
            "id":  getID("icon"),
            "style": { "backgroundSize": 70, "backgroundRepeat": "no-repeat" }
          },
          "iconMedallion": {
            "id":  getID("icon-medallion"),
            "radius": 100,
            "margin": 25,
            "style": {
              "backgroundColor": "var(--force-plain-color)",
              "border": "1px solid var(--force-mini-contast-color)",
              "boxShadow": "0 7px 5px 0px #00000012"
            }
          },
          "title": {
            "id":  getID("title"),
            "style": {
              "fontWeight": 100,
              "fontSize": 18,
              "borderBottom": "1px solid var(--force-mini-contast-color)",
              "textTransform": "uppercase"
            }
          },
          "speech_bubble": {
            "id":  getID("speech-bubble"),
            "strokeWidth": 2,
            "tailPositionX": 85,
            "style": {
              "boxShadow": "0 7px 5px 0px #00000012",
              "marginButtom": -10
            },
            "data": { "type": "html", "className": "py-2 px-3" }
          },
          "person": { "id":  getID("person"), "data": { "avatarWidth": 75, "avatarHeight": 75 } },
          "checkbox": { "id":  getID("check-box"), "style": { "padding": "10px 30px" } },
          "button": {
            "id":  getID("buttons"),
            "style": {
              "height": "auto",
              "padding": "20px",
              "paddingBottom": "auto"
            }
          },
          "divider": { "id":  getID("divider"),"divider_height": "0px" }
        },
        "cards": [
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
            },
            "iconMedallion": {
              "id":  getID("medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751110.png"
            },
            "title": { "id":  getID("title"), "data": "Втираемся в доверие" },
            "speech_bubble": {
              "data": {
                "id":  getID("bubble"),
                "data": "<p>Это всё конечно хорошо. Это просто радувает нас, как ёлочка"
              }
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "second_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg"
                }
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 0 }
              ]
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"), 
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/10751/10751146.png"
            },
            "title": {
              "id":  getID("title"),
              "data": "Комические куплеты",
              "style": { "color": "var(--actual-success-color)" }
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "102-card-1-bubble",
                "data": "<p>Реальность — это суровое место..."
              }
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "second_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg"
                }
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 0 },
                { "title": "Входим в двери", "checked": 0 },
                { "title": "Шаманим", "checked": 1 }
              ]
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Сбыча" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "103-card-1-bubble",
                "data": "<p>На Урале какие-то люди может быть есть. Тогда за три дня не удалось..."
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 0 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 1 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/7505/7505823.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Поначалу" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "104-card-1-bubble",
                "data": "<p>Нам нужен мощный телепат"
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 0 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "11",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506193.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Красные ступени" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "105-card-1-bubble",
                "data": "<p>Она хотела, чтобы ее выслушали..."
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 0 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "15",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("button"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          },
          {
            "id":  getID("card"),
            "icon": {
              "id":  getID("icon"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
            },
            "iconMedallion": {
              "id":  getID("icon-medallion"),
              "data": "https://cdn-icons-png.flaticon.com/128/7506/7506086.png"
            },
            "title": { 
              "id":  getID("title"),
              "data": "Хорошие дни" 
            },
            "speech_bubble": {
              "id":  getID("bubble"),
              "data": {
                "id": "106-card-1-bubble",
                "data": "<p>Будто ловит мысли из чужого мира."
              }
            },
            "checkbox": {
              "id":  getID("check-box"),
              "data": [
                { "title": "Поём песни", "checked": 1 },
                { "title": "Входим в двери", "checked": 1 },
                { "title": "Шаманим", "checked": 1 },
                { "title": "Обгоняем по всем параметрам", "checked": 0 }
              ]
            },
            "person": {
              "id":  getID("person"),
              "data": {
                "user": {
                  "id": "15",
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "second_name": "Савва Шехерезадович",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            "button": {
              "id":  getID("buttons"),
              "data": {
                "type": "inner_link",
                "label": "Подробнее",
                "url": "/"
              }
            }
          }
        ],
        "style": { "border": "1px solid var(--force-contast-color)" },
          defaultTitle: "Вертикальный таймлайн с внедрённым изображением"
      }
    ]
}